import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { auth, db } from '../firebase';

import {
  doc,
  onSnapshot,
  setDoc,
  deleteDoc,
  serverTimestamp,
  collection,
  getDocs,
  addDoc,
  deleteDoc as deleteDocument
} from 'firebase/firestore';


// Local contacts
function getLocalContacts() {
  try {
    return JSON.parse(
      localStorage.getItem('nexora_local_contacts') || '{}'
    );
  } catch (e) {
    return {};
  }
}


const normalizePhone = (p) => {
  if (!p) return '';

  let d = p.replace(/\D/g, '');

  if (d.startsWith('880')) {
    d = d.substring(3);
  }

  if (d.startsWith('0')) {
    d = d.substring(1);
  }

  return `+880${d}`;
};



const ProfileInfo = () => {

  const navigate = useNavigate();

  const { uid: targetUid } = useParams();


  const [currentUid, setCurrentUid] = useState(null);

  const [targetUserData, setTargetUserData] = useState(null);

  const [isBlocked, setIsBlocked] = useState(false);

  const [isPageSliding, setIsPageSliding] = useState(false);

  const [toastMsg, setToastMsg] = useState(null);
  const [reportOpen, setReportOpen] = useState(false);
  const [reportText, setReportText] = useState('');
  const [reportSending, setReportSending] = useState(false);



  const showToast = (msg) => {

    setToastMsg(msg);

    setTimeout(() => {
      setToastMsg(null);
    }, 2500);

  };





  const handleBack = () => {

    setIsPageSliding(true);

    setTimeout(() => {
      navigate(-1);
    }, 250);

  };








  useEffect(() => {

    const uid =
      localStorage.getItem('nexora_user_uid')
      ||
      auth.currentUser?.uid;



    if (!uid) {

      navigate('/login');

      return;

    }



    setCurrentUid(uid);





    // Target user data

    const userListener = onSnapshot(
      doc(db, 'users', targetUid),
      (snap) => {

        if (snap.exists()) {

          setTargetUserData(
            snap.data()
          );

        }

      }
    );







    // Block list check

    const blockListener = onSnapshot(

      doc(
        db,
        'block_list',
        uid,
        'blocked_users',
        targetUid
      ),

      (snap) => {

        setIsBlocked(
          snap.exists()
        );

      }

    );







    return () => {

      userListener();

      blockListener();

    };



  }, [targetUid, navigate]);









  const handleCopyNumber = () => {


    if (targetUserData?.phoneNumber) {


      navigator.clipboard.writeText(
        targetUserData.phoneNumber
      );


      showToast(
        "Number copied!"
      );


      if (navigator.vibrate)
        navigator.vibrate(50);


    }


  };









  const handleToggleBlock = async () => {


    if (!currentUid || !targetUid)
      return;



    const blockRef = doc(

      db,

      'block_list',

      currentUid,

      'blocked_users',

      targetUid

    );




    try {


      if (isBlocked) {


        await deleteDoc(
          blockRef
        );


        showToast(
          "User unblocked!"
        );



      } else {



        await setDoc(

          blockRef,

          {

            uid: targetUid,

            name:
            targetUserData.fullName || '',


            phoneNumber:
            targetUserData.phoneNumber || '',


            photoURL:
            targetUserData.photoURL || '',


            blockedAt:
            serverTimestamp()

          }

        );



        showToast(
          "User blocked!"
        );


      }



      if (navigator.vibrate)
        navigator.vibrate(50);



    } catch(error) {


      console.log(error);


      showToast(
        "Something went wrong!"
      );


    }


  };

  const handleReportUser = async () => {
    const reason = reportText.trim();
    if (!reason || !currentUid || !targetUserData) return;

    try {
      setReportSending(true);
      await addDoc(collection(db, 'reports'), {
        reporterUid: currentUid,
        reporterName: localStorage.getItem('nexora_current_user')
          ? JSON.parse(localStorage.getItem('nexora_current_user')).fullName || 'User'
          : 'User',
        reportedUid: targetUid,
        reportedName: targetUserData.fullName || targetUserData.phoneNumber || targetUid,
        reportedPhoneNumber: targetUserData.phoneNumber || '',
        reason,
        message: reason,
        status: 'Pending',
        createdAt: serverTimestamp(),
      });
      setReportText('');
      setReportOpen(false);
      showToast('Report submitted.');
    } catch (error) {
      console.error('User report failed:', error);
      showToast('Report could not be submitted.');
    } finally {
      setReportSending(false);
    }
  };









  // Clear Chat Function

  const handleClearChat = async () => {

    try {

      const chatId =
      [currentUid, targetUid]
      .sort()
      .join('_');



      const messagesRef =
      collection(
        db,
        'chats',
        chatId,
        'messages'
      );



      const snap =
      await getDocs(messagesRef);



      for (const item of snap.docs) {

        await deleteDocument(
          item.ref
        );

      }



      showToast(
        "Chat cleared!"
      );



    } catch(error) {

      console.log(error);

      showToast(
        "Clear chat failed!"
      );

    }

  };
  // Display Name Logic

if (!targetUserData) {

  return (

    <div style={styles.container}>

      <div style={{color:'#94a3b8',fontWeight:'600'}}>
        Loading Profile...
      </div>

    </div>

  );

}




const localContacts = getLocalContacts();

const phoneKey =
normalizePhone(
  targetUserData.phoneNumber
);


let displayName =
targetUserData.fullName
||
targetUserData.phoneNumber
||
"User";



const role =
targetUserData.role?.toLowerCase();



const specialUser =
role === "owner"
||
role === "admin"
||
role === "premium";



if(
 !specialUser &&
 localContacts[phoneKey]
){

 displayName =
 localContacts[phoneKey];

}






return (

<div style={styles.container}>


<style>{`

*{
 box-sizing:border-box;
 font-family:-apple-system,BlinkMacSystemFont,
 'Segoe UI',Roboto,sans-serif;
}


body,html,#root{

margin:0;
padding:0;
height:100%;
width:100%;
overflow:hidden;
background:#fafafa;

}



.profile-card{

width:100%;
max-width:480px;
height:100%;
background:#fafafa;
display:flex;
flex-direction:column;
animation:slideIn .25s ease;

}



.profile-card.slide-out{

animation:slideOut .25s ease;

}



@keyframes slideIn{

from{
transform:translateX(100%);
}

to{
transform:translateX(0);
}

}



@keyframes slideOut{

from{
transform:translateX(0);
}

to{
transform:translateX(100%);
}

}




.header-bar{

background:white;
padding:16px;
display:flex;
align-items:center;
gap:16px;
border-bottom:1px solid #eee;

}



.back-btn{

background:none;
border:none;
cursor:pointer;

}



.profile-content{

flex:1;
overflow-y:auto;
padding:25px 20px;
display:flex;
flex-direction:column;
align-items:center;

}




.avatar-container{

height:140px;
width:140px;
border-radius:50%;
overflow:hidden;
box-shadow:0 10px 25px rgba(0,0,0,.1);
margin-bottom:15px;

}



.avatar-img{

height:100%;
width:100%;
object-fit:cover;

}




.user-name{

font-size:24px;
font-weight:800;
margin:5px;
color:#0f172a;

}



.user-status{

color:#22c55e;
font-size:13px;
font-weight:700;

}



.offline{

color:#94a3b8;

}





.info-card{

width:100%;
background:white;
padding:15px;
border-radius:20px;
margin-top:20px;

}



.info-row{

display:flex;
justify-content:space-between;
align-items:center;
padding:12px 0;
border-bottom:1px solid #f1f5f9;

}



.info-row:last-child{

border:none;

}



.info-label{

font-size:12px;
color:#64748b;

}



.info-value{

font-size:16px;
font-weight:700;
color:#0f172a;

}




.action-btn{

width:100%;
padding:16px;
border-radius:20px;
font-size:15px;
font-weight:800;
margin-top:15px;
cursor:pointer;

}




.clear-btn{

background:#fff;
border:1px solid #e2e8f0;
color:#334155;

}



.block-btn{

background:white;
border:1px solid #fecaca;
color:#ef4444;

}



.unblock-btn{

color:#64748b;
border-color:#cbd5e1;

}

.report-btn{
background:#fff7ed;
border:1px solid #fed7aa;
color:#c2410c;
}

.profile-report-overlay{
position:fixed;
inset:0;
z-index:1000;
display:flex;
align-items:center;
justify-content:center;
padding:20px;
background:rgba(15,23,42,.55);
backdrop-filter:blur(5px);
}

.profile-report-card{
width:min(100%,380px);
padding:22px;
border-radius:22px;
background:#fff;
box-shadow:0 24px 70px rgba(15,23,42,.25);
}

.profile-report-title{font-size:20px;font-weight:900;color:#0f172a;}
.profile-report-subtitle{margin-top:5px;color:#64748b;font-size:12px;line-height:1.5;}
.profile-report-card textarea{width:100%;margin-top:16px;padding:12px;border:1px solid #e2e8f0;border-radius:14px;resize:vertical;outline:none;font:inherit;}
.profile-report-actions{display:flex;gap:9px;margin-top:14px;}
.profile-report-actions button{flex:1;padding:12px;border:0;border-radius:12px;background:#f1f5f9;color:#334155;font-weight:800;cursor:pointer;}
.profile-report-actions button:last-child{background:#ea580c;color:#fff;}




.copy-btn{

padding:8px 12px;
border:none;
background:#f1f5f9;
border-radius:10px;
font-weight:700;

}



.custom-toast{

position:absolute;
bottom:40px;
left:50%;
transform:translateX(-50%);
background:#0f172a;
color:white;
padding:10px 20px;
border-radius:20px;
font-size:13px;
z-index:999;

}


`}</style>





{
toastMsg &&
<div className="custom-toast">
{toastMsg}
</div>
}







<div className={`profile-card ${isPageSliding?'slide-out':''}`}>


<div className="header-bar">


<button
className="back-btn"
onClick={handleBack}
>


<svg width="24" height="24"
viewBox="0 0 24 24"
fill="none"
stroke="#0f172a"
strokeWidth="2.5">

<path d="M19 12H5M12 19l-7-7 7-7"/>

</svg>


</button>



<span style={{
fontSize:'18px',
fontWeight:'800'
}}>

Profile Info

</span>


</div>









<div className="profile-content">





<div className="avatar-container">

<img

src={
targetUserData.photoURL
||
"https://constructiononline.com/profile/"
}

className="avatar-img"

/>

</div>





<h2 className="user-name">

{displayName}

</h2>





<div className={
targetUserData.isOnline
?
"user-status"
:
"user-status offline"
}>

{
targetUserData.isOnline
?
"● Online"
:
"Offline"
}


</div>









<div className="info-card">



<div className="info-row">


<div>

<div className="info-label">
Mobile Number
</div>


<div className="info-value">

{
targetUserData.phoneNumber
||
"Not provided"
}

</div>


</div>





{
targetUserData.phoneNumber &&

<button
className="copy-btn"
onClick={handleCopyNumber}
>

Copy

</button>

}




</div>







<div className="info-row">


<div>


<div className="info-label">

Account Status

</div>


<div className="info-value">

{
targetUserData.role
||
"Member"
}

</div>


</div>



</div>




</div>








<button

className="action-btn clear-btn"

onClick={handleClearChat}

>

Clear Chat

</button>









<button

className={
isBlocked
?
"action-btn block-btn unblock-btn"
:
"action-btn block-btn"
}

onClick={handleToggleBlock}

>


{
isBlocked
?
"Unblock User"
:
"Block User"

}


</button>

<button
  className="action-btn report-btn"
  onClick={() => setReportOpen(true)}
>
  Report User
</button>





{
isBlocked &&

<p style={{
fontSize:'12px',
color:'#64748b',
textAlign:'center'
}}>

You blocked this user

</p>

}

{reportOpen && (
  <div className="profile-report-overlay" onClick={() => setReportOpen(false)}>
    <div className="profile-report-card" onClick={(event) => event.stopPropagation()}>
      <div className="profile-report-title">Report User</div>
      <div className="profile-report-subtitle">Tell us why you are reporting this user.</div>
      <textarea
        value={reportText}
        onChange={(event) => setReportText(event.target.value)}
        placeholder="Write a reason..."
        rows="4"
      />
      <div className="profile-report-actions">
        <button type="button" onClick={() => setReportOpen(false)} disabled={reportSending}>Cancel</button>
        <button type="button" onClick={handleReportUser} disabled={reportSending || !reportText.trim()}>
          {reportSending ? 'Sending...' : 'Submit Report'}
        </button>
      </div>
    </div>
  </div>
)}







</div>





</div>



</div>


);

};





const styles={

container:{

height:'100%',
width:'100%',
overflow:'hidden',
background:'#fafafa',
display:'flex',
alignItems:'center',
justifyContent:'center'

}

};



export default ProfileInfo;